<template>
    <b-container fluid id='container'>
        <b-row>
            <b-col md="7" offset-md="1" class="logo-container">
                <div @click="goHome()" class="logo">
                    <span class="navbar-item first-part-logo">
                        Studio dentistico
                    </span>
                    <span class="navbar-item second-part-logo">
                        Dr. R. Tintinelli Dr. G. Rossi
                    </span>
                </div>
            </b-col>
            <b-col md="4">
                <b-dropdown variant="outline-success" v-if="isLoggedIn" :text="userName()" @click="getUserType">
                    <b-dropdown-item v-if="getUserType().includes('admin')" @click="goToAdmin" >
                        Admin
                    </b-dropdown-item>
                    <b-dropdown-item @click="logOut">
                        Log out
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: "Navbar",
  data (){
      return{
        isLoggedIn: Boolean,
        // usertype: this.$store.getters['getUser'].user_type,
        // key: 0
      }
  },
  props: {
    userType: String
  },
  methods: {
      goHome: function(){
            let userType=this.$store.getters['getUser'].user_type;
            if (userType.includes('labs')){
                this.$router.push('/dashboard-lab').catch(err => console.log(err));
                return;
            }
            if (userType.includes("admin") || userType.includes("dottori") || userType.includes("gestori")){
                this.$router.push('/dashboard');
                return;
            }
            this.$router.push('/');
          
      },
      userName: function(){
        //   return localStorage.getItem('userName');
        return this.$store.getters['getUser'].full_name;
      },
      logOut: function(){
        this.$store.dispatch("logOut")
        localStorage.removeItem('access_token');
        window.dispatchEvent(new CustomEvent('setUsername'));
        this.$router.push('/');
        // console.log(this.key)
      },
      setLoginStatus: function(){
        if (this.$store.getters['isLoggedIn'])
            this.isLoggedIn = true;
        else this.isLoggedIn = false;
      },
      getUserType: function() {
        return this.$store.getters['getUser'].user_type;
      },
      goToAdmin: function(){
          this.$router.push('/admin')
      },
    //   isUserStudio: function(){
    //     let userType = this.getUserType();
    //     if( userType == "admin" || userType == "gestori" || userType == "dottori")
    //         return true;
    //      else return false; 
    //   },
    //   goToCreatePratica: function() {
    //       this.$router.push("/nuova-pratica")
    //   }
  },
  mounted() {
    this.setLoginStatus();
    window.addEventListener('setUsername', () => {
        this.setLoginStatus();
    });
  },
};
</script>

<style scoped>
    #container{
        height:80px;
        padding-top: 25px;
        box-shadow: 0px 2px 5px #6ABF67;
        position: relative;
        z-index: 1;
    }
    .logo {
        font-weight: bold;
        font-size: 21px;
        cursor: pointer;
    }
    .first-part-logo{
        color: #c6c6c6;
    }
    .second-part-logo{
        color: #6abf61;
    }
    .logo-container{
        text-align: left;
    }
    .menu-container{
        text-align: right;
    }
    .navbar-item{
        height: 100%;
        vertical-align: -webkit-baseline-middle;
    }
</style>